module.exports = __webpack_public_path__ + "images/onboarding-banner/banner-wave-right.08e4434dee2e3b7730b3.svg";